<template lang="">
  <div class="app-toast--breaking-changes app-toast is--error is--inline">
    <div class="app-toast__text">
      <p class="app-toast__title">Warning: There has been a new release with breaking change(s)</p>
      <p>Some content, which is marked by a warning or error icon, needs to be resaved or updated due to recent changes. Click “Learn more” to see what has changed.</p>
    </div>
    <div class="app-toast__buttons">
      <a href="https://fabric.ey.com/explore/eydx/content/87284bce-f187-4bdf-9f72-0e927e359c26" target="_blank" class="element-button element-button--text">
        <svg class="element-icon--open-new-window element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-open-new-window"></use></svg>
        Learn more
      </a>
      <label class="element-toggle" v-if="toggle">
          <input class="element-toggle__toggle" type="checkbox" v-model="toggleBreakingChanges" />
          <span class="app-project-dashboard__schema-alert-toggle-track"></span>
          <span>Filter breaking changes</span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    toggle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      toggleBreakingChanges: false
    };
  },
  watch: {
    toggleBreakingChanges(newValue) {
      this.$emit('toggle', newValue);
    }
  },
  mounted() {

  }
}
</script>